import { render } from "./Monochrome.vue?vue&type=template&id=7cc687e6"
import script from "./Monochrome.vue?vue&type=script&lang=js"
export * from "./Monochrome.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__